import { useEffect, useRef } from "react";
import { PAYPAL } from "../data";

let sdkPromise = null;

function loadSdk(clientId) {
  if (typeof window !== "undefined" && window.paypal && window.paypal.HostedButtons) {
    return Promise.resolve();
  }
  if (sdkPromise) return sdkPromise;
  sdkPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&components=hosted-buttons&enable-funding=venmo&currency=USD`;
    s.async = true;
    s.onload = resolve;
    s.onerror = reject;
    document.body.appendChild(s);
  });
  return sdkPromise;
}

export default function PayPalButton({ hostedButtonId }) {
  const ref = useRef(null);
  const rendered = useRef(false);

  useEffect(() => {
    let cancelled = false;
    rendered.current = false;
    loadSdk(PAYPAL.clientId)
      .then(() => {
        if (cancelled || rendered.current || !ref.current) return;
        if (window.paypal && window.paypal.HostedButtons) {
          rendered.current = true;
          while (ref.current.firstChild) ref.current.removeChild(ref.current.firstChild);
          window.paypal.HostedButtons({ hostedButtonId }).render(ref.current);
        }
      })
      .catch((err) => {
        console.error("PayPal SDK failed to load:", err);
      });
    return () => {
      cancelled = true;
    };
  }, [hostedButtonId]);

  return (
    <div
      ref={ref}
      data-testid={`paypal-button-${hostedButtonId}`}
      className="bg-white p-3 rounded-sm"
    />
  );
}
